import React from "react";
import { useEffect, useState } from "react";
import { Box, Grid, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import Carousel from "react-material-ui-carousel";
import ContentCards from "../components/homepage/contentCards";
import CustomizedAccordions from "../components/homepage/accordion";
import CustomContainer from "../components/layout/container";
import CustomHeader from "../components/layout/header";
import ContactForm from './ContactForm';

import subscribe3Arrows from "../images/3ArrowsPurpleWide.jpg";
import subscribeNormDist from "../images/NormalDistribCropTeal.jpg";
import subscribeDataGraph from "../images/DataGraphsPaleMauve.jpg";
import subscribeEducCrest from "../images/EducationCrestGreen.jpg";

const carouselHeight = "150px";
const Subscribe = () => {
  const theme = useTheme();
  const smScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const { subscribeSubPage } = useParams();

  const router = useNavigate();
  const [pageTitle, setPageTitle] = useState("");
  const [links, setLinks] = useState("");
  const [borderColorToHighlight, setborderColorToHighlight] = useState("");

  const getRouterData = () => {
    if (subscribeSubPage) {
      const url = subscribeSubPage.replace(/-/g, " ");
      setLinks(url);
      const finalString = url.split(" ")
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
      setPageTitle(finalString);
      setTimeout(() => {
        setborderColorToHighlight(theme.palette.primary.dark);
      }, 100);
    }
  };

  const breadcrumbData = [
    {
      name: "Home",
      link: "/",
    },
    {
      name: `Subscribe (${pageTitle})`,
      link: `/subscribe/${subscribeSubPage}`,
    },
  ];

  const [showForm, setShowForm] = useState(false);

  useEffect(() => {
    getRouterData();
  }, [subscribeSubPage]);

  return (
    <Box>
      <CustomContainer>
        <title>Subscribe | Manchester Economic Forecasting</title>
        <meta
          name="description"
          content=" Identify & Quantify Macroeconomic/Esg risk"
        />
      </CustomContainer>
      <CustomHeader
        title={`Subscribe ?<span style="font-size: 20px;color:rgba(84,77,160,1);">- Users of MEF Services: </span> `}
        breadcrumbData={breadcrumbData}
      />

      <Box sx={{ textAlign: 'left', my: 1, px:1 }}> {/* Added Box for placeholder styling */}
      <Typography variant="body1" color="rgba(84,77,160,1)" sx={{ mb: 2 }}>
      If you would like to discuss your needs with an MEF representative, please leave your details{' '}
      <span 
        style={{ 
          textDecoration: 'underline', 
          cursor: 'pointer', 
          fontWeight: 'bold' 
        }}
        onClick={() => setShowForm(!showForm)}
      >
        here
      </span>:
    </Typography>
    {/* Conditionally render the form only when showForm is true */}
      {showForm && (
        <Box sx={{ my: 2 }}>
          {/* Pass setShowForm as a prop to the child component */}
          <ContactForm onSuccess={() => setShowForm(false)} />
        </Box>
      )}
    <Typography variant="body1" color="rgba(84,77,160,1)" sx={{ mt: 3 }}>
      Subscription options/features are set out below:
    </Typography>
      </Box>
      <CustomContainer>
        <Box >
          {/* <Typography
          color="#00a0a0" variant="h3" align="left" fontWeight={700} mb={1.5} >
        Users of MEF Services: <span style="font-size:1.2rem;color:rgba(84,77,160,1);"> - Smart Economic Scenarios/Apps to Mitigate Global Risk</span>
        </Typography> */}

          {/* MT - Need to remove breadcrumb as causing subtitle to wrap !! */}

          <Grid container spacing={1.5}>
            <Grid item xs={12} sm={6} md={3.0}>
              <ContentCards
                imgSrc={subscribe3Arrows}
                title="Exporters/SMEs & Consultancies"
                objectFit="contain"
                subTitle="Quantify Global Demand/Cost Risks"
                email="scenarios@mef-uk.com"
                borderColor={ links == "exporters sme" ? borderColorToHighlight : "none" }
                body={`Using MEF's <a href='/how/mGEM-global-macro' title="macro Global Econometric Model">mGEM</a> model, we start from <b>Official macro/budget</b> announcements as a
              central economic forecast projection or baseline. MEF can then scenario-test critical official assumptions (eg interest/exchange rates) of that baseline that impact a client's specific business areas to quantify <b>de-facto risk exposure</b> to the global economy`}
              />
              {/* <CustomizedAccordions
              title="Pre-Run Scenario Service"
              body={`In more detailed, bespoke scenario analysis, MEF can test particular, client-specific, risk concerns over official macro/energy/emissions forecasts
              - it might be that some announced policy settings are not deemed credible even thought they are crucial drivers of official forecasts. `}
            /> */}
              <CustomizedAccordions
                title="risk2NZ App - Pre-Run Macro Scenarios"
                body={`Each quarter, MEF produces several,highly-relevant, pre-configured macro scenarios which cover significant current areas of both macro
              and financial risk at Global and/or UK levels. MEF's <a title="risks to Net Zero" href='/what/risk2NZ-app'> risk2NZ </a> App contains a number of these, pre-configured
              scenarios that explore "shocks" to key exogenous/policy inputs (eg US Federal Funds interest rate) to quantify sensitivities of official Economic/Energy forecasts.
              risk2NZ contains the animated country response output charts & Global, geographic heatmaps to help visualise & interpret scenario impacts & spillovers.
              The <b>"Macro-Map</b>", "<b>Links-Trade</b>" and "<b>Links-Macro</b>" are the most relevant Tabs in risk2NZ for Exporters/SMEs.
              MEF can also make its pre-run scenario outputs available for clients who simply wish to access fully-consistent, global drivers of their own
              in-house, domain-level, scenario analysis`}
              />
              <CustomizedAccordions
                title="Bespoke Scenarios/Models-mGEM driven"
                body={`MEF can tailor its bespoke scenario service to serve clients who also wish to commission proprietary models that forecast their specific domains/markets.
              The client will then typically own the bespoke model, but it is built, run & maintained by MEF, thereby enabling <a href='/how/mGEM-global-macro'  title="macro Global Econometric Model">mGEM</a> macro scenarios
              outputs can be seamlessly fed into it, if required.
              MEF can also construct SME-specific weighted indices of overall export/demand prospects across all the SME's key export markets. mGEM shocks at a global/national
              level can then be translated into market-specific impacts for customised SME risk analysis.  `}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3.0}>
              <ContentCards
                imgSrc={subscribeNormDist}
                title="Investment/Fund Managers"
                subTitle="Explore Portfolio/Esg Risk"
                email="portfolio@mef-uk.com"
                // MT added
                objectFit="contain"
                borderColor={
                  links == "investment managers"
                    ? borderColorToHighlight
                    : "none"
                }
                body={`Using MEF's <a title="finance Global Econometric Model" href='/how/finGEM-global-finance'>finGEM</a> and <a title="energy Global Econometric Model" href='/how/enGEM-global-energy'>enGEM</a> models, we can explore both
              <b>macro, technology and (Green) policy shocks</b> impacting both investment returns and broader global trajectories to Net Zero carbon. Such Portfolio "stress-tests"
              also reveal the related Corporate winners/losers - and equity valuations - in the global energy transition to 2050.`}
              />
              <CustomizedAccordions
                title="risk2NZ App Macro-Financial Scenarios"
                body={`.MEF's pre-run scenarios  can assist <b>investment committees</b> and other investment professionals & wealth managers
              in seeking to quantify Portfolio exposure in a highly uncertain global economy facing multiple, ongoing shocks.
              The <a title="risks to Net Zero" href='/what/risk2NZ-app'> risk2NZ </a> App allows users to explore these scenarios & the
              shock-impacts on typical investment Portfolios and/or upload their own Portfolio for more direct stress-testing. It also allows
              users to inspect latest Esg ratings for typical investment portfolios (eg 60:40 Equity:Bonds) and the ability to input their own
              Portfolio asset allocation across Countries, Assets & Sectors to obtain an instant Esg-rating`}
              />
              <CustomizedAccordions
                title="Bespoke Portfolio Modelling & Esg Fund-Ratings"
                body={`MEF can construct customised, satellite Portfolio models with explicit macro-financial linkages to key drivers variables in the MEF model suite; this enables the
              modelling & direct quanfitication of portfolio returns risk from macro/energy shocks. MEF can also <a title="Environmental, Societal & Governmental"> Esg</a>-rate Funds by mapping Country-Sector exposure
              of underlying investments to the <a title="GreenHouse Gases"> GHG</a> intensities in MEF models -we call this an <b>"Esg"</b> Fund rating as it focuses on "hard" Emissions/Energy data for "E" `}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3.0}>
              <ContentCards
                imgSrc={subscribeDataGraph}
                title="Energy/Emissions Analysts"
                subTitle="Test Emissions-Macro Sensitivities"
                email="scenarios@mef-uk.com"
                // MT added
                objectFit="contain"
                borderColor={
                  links == "energy analysts"
                    ? borderColorToHighlight
                    : "none"
                }
                body={`Energy/Emissions forecasts are often based on simplistic <b>"straight-line" assumptions</b> about global economic activity. Using MEF's <a href='/how/eGEM-global-emissions'  title="industry Global Econometric Model">iGEM</a>  and <a href='/how/enGEM-global-energy' title="emissions Global Econometric Model">eGEM</a> models, we can derive
              "bottom-up" (ie adjusted for industry-mix) forecasts & scenarios for Energy/Emissions that are fully consistent with more <i>realistic</i> <a href='/how/mGEM-global-macro'  title="macro Global Econometric Model">mGEM</a> forecast/scenario pathways.`}
              />
              <CustomizedAccordions
                title="risk2NZ App Macro-Emissions Scenarios"
                body={`
              Macroeconomic and/or GreenTech scenario analysis is essential to explore huge uncertainties in (global) economic & technological pathways to 2050
              Output growth dominated by <a title="GreenHouse Gases"> GHG</a>-intensive sectors will obviously imply higher national emissions than otherwise - so understanding the industrial mix
              of output evolution is crucial for Net Zero analysis/predictions. <a title="industry Global Econometric Model">iGEM</a> allows the feed-through of mGEM global/national shocks to 12 industrial sectors across the majority of the 53 economies/zones covered by mGEM.
              MEF's <a title="risks to Net Zero" href='/what/risk2NZ-app'> risk2NZ </a> App can also explore impacts of (Global) macro scenarios on Corporate decarbonisation trajectories relative to sectoral Carbon Intensity budgets see "<b>GHG-Firms</b>" Tab`}
              />
              <CustomizedAccordions
                title="Bespoke Energy/Emissions Models & Pathways"
                body={` MEF can construct customised client models that are driven by by either macro and/or industrial-sector outputs from MEF's model suite. Energy/Emissions
              analysts can then ensure their 2050 pathways are fully consistent with realistic, global, macroeconomic driver variables; and that the latter drivers can then be fully
              "stress-tested" in a consistent way using bespoke scenario analysis. `}
              //              MEF can conduct macro-industrial sector risk analysis using mGEM add-on <a title="industry Global Econometric Model">iGEM</a>; capture Sectoral & Energy/Emissions impacts of global macro shocks maybe from a bespoke macro forecast base.
              //              Such Global/National shocks can then reveal Corporate level Carbon exposure and thus Green taxation exposure
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3.0}>
              <ContentCards
                imgSrc={subscribeEducCrest}
                title="Higher Education Institutes"
                subTitle="Real World Risk Models/Tools/Apps"
                email="education@mef-uk.com"
                // MT added
                objectFit="contain"
                borderColor={
                  links == "hg institutions"
                    ? borderColorToHighlight
                    : "none"
                }
                body={`<a href='/what/risk2NZ-app' title="risks to Net Zero mobile App" > risk2NZ </a> App brings Business, Investment and<a title="Environmental,
               Societal & Governmental"> Esg </a> <b>risk/scenario analysis to the classroom</b> - from undergraduate, postgrad/MBA to Executive Education. Its fully customisable to courses
              across Economics, Business/Finance, Geography/Climate, Econometrics/Data Science - a key data tool for lectures and (self-directed) student tutorials.`}
              />
              <CustomizedAccordions
                title="Business Risk Tools in Class & stuGEM Model"
                body={`<a title="risks to Net Zero" href='/what/risk2NZ-app'> risk2NZ </a> App is a front-end to MEF's model suite that is configurable for subject area deployment[; a free lite version
                of the App is available for download/assessment: - <a href="/download/riskNZliteSignUp.tsx">Sign Up Here</a> The full App enables students to be fully grounded in applied data awareness,
                policy trade-offs and operation of  smart scenario analysis; it helps fills the gap in most (theory-dominated) course units in Economics, Business & Finance. In this way, students
                are prepared in advance with the applied skills/tools needed to assist in Carbon transformation in their future careers. <br />
                <b>HE Forecasts/Scenarios: International Students</b> - MEF has developed a forecasting/scenario model of International Student Flows to the UK using official HESA data.
                The <a title="student Global Econometric Model"> stuGEM </a> module models inward student flows to the UK driven by Global/National macroeconomic drivers. 
                The recent "China slowdown" shock (post-COVD) illustrates the need to "stress-test" key assumptions around future (international) student numbers/revenues`}              
              />
              <CustomizedAccordions
                title="Custom Applied Course Units"
                body={`MEF has a long history of devising and delivering custom education courses for University/CPD qualifications. It can bring business-level applied risk tools, modals & data into the classroom.
              Custom programs designed around applied business risk tools - such as <a title="risks to Net Zero" href='/what/risk2NZ-app'> risk2NZ </a> - help to maximise Macro/Emissions & <a title="Environmental, Societal & Governmental"> Esg </a> awareness among Economics, Finance & MBA students.
              <a title="risks to Net Zero" href='/what/risk2NZ-app'> risk2NZ </a> is also ideal for CPD & staff training up-skilling.
              It can be readily deployed in remote-learning environments too and has in-built MCQ testing/scoring &  progress monitoring`}
              />
            </Grid>
          </Grid>
        </Box>
      </CustomContainer>
    </Box>
  );
};

export default Subscribe;

// Mobile Apps and Webtools - powered by Global models/data
